import { type CSSColor, generateColorRamps } from '../../common/utils/color-ramps-generator';
import type { BrandingTheme } from '../../types';

// Values are taken from figma [design](https://www.figma.com/design/sxl0BlQxD2g2eU27Rl2VhG/CSM-X-Loom-Support---In-Product?node-id=2351-34333&t=d8zOoCnHa3EJORFr-4), some are guesstimated
const BORDER_RADIUS = {
	sharp: {
		lg: '8px',
		md: '4px',
		sm: '2px',
		container: '12px',
		widget: '12px',
	},
	normal: {
		lg: '10px',
		md: '6px',
		sm: '4px',
		container: '18px',
		widget: '18px',
	},
	rounded: {
		lg: '12px',
		md: '10px',
		sm: '6px',
		container: '22px',
		widget: '100%',
	},
};

const SPACE = {
	cosy: {
		lg: '12px',
		md: '8px',
		sm: '8px',
	},
	comfortable: {
		lg: '16px',
		md: '12px',
		sm: '8px',
	},
	generous: {
		lg: '24px',
		md: '16px',
		sm: '8px',
	},
};

export const generateThemeBranding = (
	themeConfig: BrandingTheme,
): {
	colorRamps: {
		color100: string;
		color200: string;
		color300: string;
		color400: string;
		color500: string;
		color600: string;
		color700: string;
		color800: string;
		color900: string;
		color1000: string;
	};
	borderRadius:
		| {
				lg: string;
				md: string;
				sm: string;
				container: string;
				widget: string;
		  }
		| {
				lg: string;
				md: string;
				sm: string;
				container: string;
				widget: string;
		  }
		| {
				lg: string;
				md: string;
				sm: string;
				container: string;
				widget: string;
		  };
	space:
		| {
				lg: string;
				md: string;
				sm: string;
		  }
		| {
				lg: string;
				md: string;
				sm: string;
		  }
		| {
				lg: string;
				md: string;
				sm: string;
		  };
} => {
	const { radius, space, primaryColor } = themeConfig;
	const colorRamps = generateColorRamps(primaryColor as CSSColor);
	const borderRadius = BORDER_RADIUS[radius] || BORDER_RADIUS.normal;
	const themeSpace = SPACE[space] || SPACE.comfortable;

	return {
		colorRamps,
		borderRadius,
		space: themeSpace,
	};
};
